module.exports = __webpack_public_path__ + "img/gestion_operativa.ec605f03.jpeg";